import { computed, ref } from 'vue';
import { useApiModel } from '~/composables/useApiModel';
import type { EntityTag, SourceLink } from '~/types/Candidates';
import { mapEntityTags, type ApiTagEntity } from '~/utils/mapEntityTags';
import { mapSourceLink, type ApiSourceLike } from '~/utils/mapSourceLink';

interface ApiSource extends ApiSourceLike {
  is_general: boolean;
  candidates?: ApiTagEntity[];
  parties?: ApiTagEntity[];
  campaigns?: ApiTagEntity[];
}

export interface SourceWithTags extends SourceLink {
  tags: EntityTag[];
}

export function useSources() {
  const model = useApiModel<ApiSource>('sources', {
    limit: ref(50),
    // `useApiModel` has no dedicated `include` option; its `load()` spreads
    // `filters` directly into the request params, so this is the supported
    // way to make the relation includes land in the emitted query string.
    filters: ref({ include: 'candidates,parties,campaigns' }),
    immediate: true,
  });

  const sources = computed<SourceWithTags[]>(() =>
    model.items.value.map((source) => ({
      ...mapSourceLink(source),
      tags: [
        ...mapEntityTags('candidate', source.candidates),
        ...mapEntityTags('party', source.parties),
        ...mapEntityTags('campaign', source.campaigns),
      ],
    })),
  );

  return { sources, pending: model.pending, error: model.error };
}
